// src/api/modules/DisposalApi.js
import Methods from "../methods";

const searchDisposals = (context, idClient, payload) => {
  const {filters, page, size, sortBy = "registrationDate", direction = "desc"} = payload;

  const url = `disposals/search/${idClient}?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const saveDisposal = (context, payload) => {
  const url = `disposals`;
  return Methods.doPost(context, url, payload, null);
};

const getDisposalById = (context, idClient, id) => {
  const url = `disposals/${idClient}/${id}`;
  return Methods.doGet(context, url);
};

const cancelDisposal = (context, idClient, idDisposal) => {
  const url = `disposals/${idClient}/${idDisposal}/cancel`;
  return Methods.doPut(context, url, null);
};

export default {
  searchDisposals,
  saveDisposal,
  getDisposalById,
  cancelDisposal,
};



// WEBPACK FOOTER //
// ./src/api/modules/DisposalApi.js